/**
 * Enum for the different types of coupons.
 */
export enum CouponTypes {
  Percentage = 'Percent',
  DollarAmount = 'Amount',
}
